import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { clearChunkReloadFlag } from './utils/lazyWithRetry'

// Si la app bootea bien, el flag de reload queda limpio para futuros deploys
clearChunkReloadFlag()

// StrictMode deshabilitado temporalmente para evitar doble-mount con Supabase
createRoot(document.getElementById('root')!).render(
  <App />
)
